<template>
<div class="chapter">
<div class="inner_page">
<p class="dedicationa"><a id="page_v"></a><img alt="Image" src="images/f0006-01.jpg"/></p>
<p class="dedication"><strong>This book is dedicated to Mom and Dad for always encouraging me,<br/>and my brother, Tom, for renewing my interest in rap music.</strong></p>
<p class="indent"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?36049d9b